// Amplitude configuration
const getAmplitudeApiKey = () => {
  const hostname = window.location.hostname;

  // Production domain
  if (hostname === "survey.wiseradvisor.com") {
    return "d0d1e928fcbca1282e1f357f9517cd1e";
  }

  // All other domains (staging, dev, local)
  return "d09192eb5831f1a7fb4f517d6cf73d83";
};

export const AMPLITUDE_CONFIG = {
  API_KEY: getAmplitudeApiKey(),
  OPTIONS: {
    defaultTracking: {
      sessions: true,
      pageViews: true,
      formInteractions: true,
      fileDownloads: true,
    },
  },
};

// Event names for consistency
export const AMPLITUDE_EVENTS = {
  SURVEY_STARTED: "survey__start__survey",
  SURVEY_VIEW_STEP: "survey__view__step",
  SURVEY_STEP_COMPLETED: "survey__submit__step",
  SURVEY_STEP_NAVIGATED_BACK: "survey__click__back",
  SURVEY_ANSWER_SUBMITTED: "survey__submit__answer",
  SURVEY_ANSWER_SUBMISSION_ERROR: "survey__submit__error",
  SURVEY_COMPLETED: "survey__complete__survey",
  FIVE_STAR_RATING_GIVEN: "survey__submit__5star",
  NON_FIVE_STAR_RATING_GIVEN: "survey__submit__non5star",
};
